<footer class="flex h-full items-center bg-primary-footer text-white dark:bg-contrast-black" role="contentinfo">
    <div class="mx-auto w-full max-w-screen-xl px-6 md:px-10 lg:px-20">
        <div class="footer-columns flex flex-col lg:flex-row">
            <div class="footer-contact-column mb-8 mt-10 text-xs lg:-ml-4 lg:mb-0 lg:mr-32 lg:mt-0 lg:w-[20%]">
                <img
                    class="footer-logo mb-6 h-[64.3px] w-[75px] object-contain dark:hidden"
                    src="{{ assetsPath$ | async }}/img/{{ logoFile }}"
                    alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />
                <img
                    class="footer-logo mb-6 hidden h-[64.3px] w-[75px] object-contain dark:block"
                    src="{{ assetsPath$ | async }}/img/{{ logoFileContrast }}"
                    alt="{{ 'LOGO_ARIA_LABEL' | translate }}" />

                <div class="space-y-2">
                    <p class="">{{ 'FOOTER_CONTACTS_COMPANY_NAME' | translate }}</p>
                    <p>{{ 'FOOTER_CONTACTS_COMPANY_ADDRESS' | translate }}</p>
                    <p>
                        <a
                            class="hu-light:text-white"
                            href="mailto:{{ 'FOOTER_CONTACTS_COMPANY_EMAIL' | translate }}"
                            target="_blank"
                            >{{ 'FOOTER_CONTACTS_COMPANY_EMAIL' | translate }}</a
                        >
                    </p>
                    <p>
                        <a
                            class="hu-light:text-white"
                            href="tel:{{ 'FOOTER_CONTACTS_COMPANY_PHONE' | translate }}"
                            target="_blank"
                            >{{ 'FOOTER_CONTACTS_COMPANY_PHONE' | translate }}</a
                        >
                    </p>
                </div>

                <div class="mt-6">
                    <a
                        class="fb-icon-wrapper hu-dark:!bg-contrast-yellow inline-flex h-5 w-5 items-center justify-center rounded-full bg-white p-1 transition-colors duration-300"
                        target="_blank"
                        href="{{ 'FOOTER_FACEBOOK_URL' | translate }}"
                        rel="noopener">
                        <mat-icon
                            class="!flex !h-3 !w-3 !items-center !justify-center !fill-primary text-primary !transition-colors !duration-300 dark:filter-black"
                            svgIcon="facebook"></mat-icon>
                    </a>
                </div>
            </div>

            <div class="flex flex-col lg:flex-1 lg:flex-row lg:justify-between">
                <div class="text-sm lg:w-[23%]">
                    <h2
                        class="hu-dark:text-contrast-yellow mb-2 mt-8 font-medium uppercase text-primary lg:mb-4 lg:mt-0">
                        {{ 'FOOTER_PASSENGER_INFO' | translate }}
                    </h2>
                    <ul class="!leading-8">
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_PEUTK_FAQ_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_FAQ' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_NEWS_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_NEWS' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_GIVE_FEEDBACK_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_GIVE_FEEDBACK' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_CONTACTS_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_CONTACTS' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_LOST_AND_FOUND_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_LOST_AND_FOUND' | translate }}</a
                            >
                        </li>
                    </ul>
                </div>

                <div class="text-sm lg:w-[23%]">
                    <h2
                        class="hu-dark:text-contrast-yellow mb-2 mt-8 font-medium uppercase text-primary lg:mb-4 lg:mt-0">
                        {{ 'FOOTER_TRAVEL_INFO' | translate }}
                    </h2>
                    <ul class="!leading-8">
                        <li>
                            <a
                                class="footer-link"
                                [routerLink]="'/explore' | localize"
                                routerLinkActive="router-link-active">
                                {{ 'FOOTER_SCHEDULE' | translate }}
                            </a>
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                [routerLink]="'/journey-planner' | localize"
                                routerLinkActive="router-link-active">
                                {{ 'FOOTER_JOURNEY_PLANNER' | translate }}
                            </a>
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_COMBINED_TIMETABLES_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_COMBINED_TIMETABLES' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_MUNICIPAL_INTERNAL_ROOTS_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_MUNICIPAL_INTERNAL_ROOTS' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_ONDEMAND_TRIPS_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'ONDEMAND_TRIPS' | translate }}</a
                            >
                        </li>
                    </ul>
                </div>

                <div class="text-sm lg:w-[23%]">
                    <h2
                        class="hu-dark:text-contrast-yellow mb-2 mt-8 font-medium uppercase text-primary lg:mb-4 lg:mt-0">
                        {{ 'FOOTER_HEADING_TICKETS' | translate }}
                    </h2>
                    <ul class="!leading-8">
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_TICKET_FARES_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_TICKET_FARES' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                [routerLink]="'/purchase/ticket' | localize"
                                routerLinkActive="router-link-active">
                                {{ 'FOOTER_BUY_PERIOD_TICKET' | translate }}
                            </a>
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_TRAVEL_CARD_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_TRAVEL_CARD' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_STUDENT_ID_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_STUDENT_ID' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_BANKCARD_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'BANK_CARD' | translate }}</a
                            >
                        </li>
                    </ul>
                </div>

                <div class="text-sm lg:w-[26%]">
                    <h2
                        class="hu-dark:text-contrast-yellow mb-2 mt-8 font-medium uppercase text-primary lg:mb-4 lg:mt-0">
                        {{ 'FOOTER_COMPANY_HEADING' | translate }}
                    </h2>
                    <ul class="!leading-8">
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_ABOUT_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_ABOUT' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_CONTACTS_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_CONTACTS' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_PARTNERS_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_PARTNERS' | translate }}</a
                            >
                        </li>
                        <li>
                            <a
                                class="footer-link"
                                href="{{ 'FOOTER_DOCUMENTATION_LINK' | translate }}"
                                target="_blank"
                                rel="noopener"
                                >{{ 'FOOTER_DOCUMENTATION' | translate }}</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>

<footer class="bg-white py-4" *ngIf="(showExtraFooter$ | async) && env.REGION_ID === 2" role="contentinfo">
    <div class="max-content">
        <img
            class="h-16 object-contain"
            src="{{ assetsPath$ | async }}/footer-logo.svg"
            alt="{{ 'LOGO' | translate }}"
            width="150"
            height="70" />
    </div>
</footer>
